export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '발주자'}, {name: '설계자'}, {name: '시공자'}, {name: '작성부서'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).businessInfo.field_name // 사업장명
      case 1: return func.getContent(value).inputC_5 // 발주자
      case 2: return func.getContent(value).inputD_5 // 설계자
      case 3: return func.getContent(value).inputE_3 // 시공자
      case 4: return func.getContent(value).stdInfo.com_name // 작성부서
      case 5: return value.user ? value.user.name : value.author.name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {

    const returnData = []

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.businessInfo.field_name*%[:default_skw]%'); break
    case '발주자': returnData.push('content$body.inputC_5*%[:default_skw]%'); break
    case '설계자': returnData.push('content$body.inputD_5*%[:default_skw]%'); break
    case '시공자': returnData.push('content$body.inputE_3*%[:default_skw]%'); break
    case '작성부서': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
